module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl2-50.6f81227c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/CommandCenter/images/command-center-lvl2-50.png
// module id = 3274
// module chunks = 11